export default{
    actions: {
      
    },
    mutations: {
    addpostobv(state, newpost){
         state.postobv=newpost;
    },
    addpostimgobv(state, newpost){
         state.postimg=newpost;
    },
    addpostparametrobv(state, newpost){
        state.parametr=newpost;
   },
    addsedichkaobv(state){
      state.postobv.serdichka = !state.postobv.serdichka;
    }
    },
    state: {
        postobv: [],
        postimg:[],
        parametr:[]
    },
    getters:{
        getpostobv(state){
            return state.postobv
        }, 
        getpostimgobv(state){
            return state.postimg
        },
        getpostparametrobv(state){
            return state.parametr
        }, 
    }
}